<template>
  <div>
    <h1>Divider 分割线</h1>
    <p class="page-desc">区隔内容的分割线。</p>

    <demo-viewer title="水平分割线" :code="SPFGX" desc="默认为水平分割线">
      <div class="purity-bg">
        <p>Put some music on that's soft and slow</p>
        <k-divider />
        <p>Baby we ain't got no place to go</p>
        <k-divider dashed />
        <p>I hope you understand</p>
      </div>
    </demo-viewer>

    <demo-viewer
      title="带文字的分割线"
      :code="DWZDFGX"
      desc="分割线中带有文字，可以用 orientation 指定文字位置。"
    >
      <div class="purity-bg">
        <p>Put some music on that's soft and slow</p>
        <k-divider orientation="left">居左</k-divider>
        <p>Baby we ain't got no place to go</p>
        <k-divider>居中</k-divider>
        <p>I hope you understand</p>
        <k-divider orientation="right">居右</k-divider>
        <p>I've been thinking 'bout this all day long</p>
      </div>
    </demo-viewer>

    <demo-viewer
      title="垂直分割线"
      :code="CZFGX"
      desc="使用 type='vertical' 设置为行内的垂直分割线。"
    >
      <div class="purity-bg">
        <k-button icon="delete" />
        <k-divider type="vertical" />
        <k-button>按钮</k-button>
        <k-divider type="vertical" />
        文字
      </div>
    </demo-viewer>

    <table class="doc-table">
      <caption>
        <h3>属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>type</td>
          <td>水平还是垂直类型，可选值为 horizontal 或 vertical</td>
          <td>String</td>
          <td>horizontal</td>
        </tr>
        <tr>
          <td>orientation</td>
          <td>分割线标题的位置，可选值为 left、right 或 center</td>
          <td>Number</td>
          <td>center</td>
        </tr>
        <tr>
          <td>dashed</td>
          <td>是否虚线</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SPFGX: `
  <template>
    <k-divider />
    <k-divider dashed />
  </template>
  `,
      DWZDFGX: `
  <template>
    <k-divider orientation="left">居左</k-divider>
    <k-divider>居中</k-divider>
    <k-divider orientation="right">居右</k-divider>
  </template>
      `,
      CZFGX: `
  <template>
    <k-divider type="vertical" />
  </template>
      `
    };
  }
};
</script>
